import { useState } from "react";
import {
  Input,
  InputRightElement,
  InputLeftElement,
  InputGroup,
  Image,
  Button,
  Text,
  Flex,
} from "@chakra-ui/react";

const Searchbar = ({ onChange, title }) => {
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    setValue(e.target.value);
    onChange(e.target.value);
  };

  const clear = () => {
    setValue("");
    onChange("");
  };

  return (
    <Flex gap={"8px"} direction={"column"}>
      {title && (
        <Text
          paddingLeft={"5px"}
          fontSize={14}
          textColor={"#898989"}
          fontFamily={"PlusJakartaSansMedium"}
        >
          {title}
        </Text>
      )}
      <InputGroup>
        <InputLeftElement
          display={"flex"}
          alignItems={"center"}
          height={"100%"}
        >
          <Image
            style={{ color: "#898989" }}
            src={require("assets/svgs/search.svg").default}
          />
        </InputLeftElement>
        <Input
          value={value}
          onChange={(e) => handleChange(e)}
          placeholder={"Search Your Product Here...."}
          bg={"#fff"}
          fontFamily={"PlusJakartaSansMedium"}
          borderRadius={0}
          fontSize={14}
          width={"360px"} // Increased width
          height={"48px"} // Increased height
          border={"none"} // Removed border
          _focus={{
            boxShadow: "none", // Removed focus outline
            border: "none", // No border on focus
          }}
        />
        <InputRightElement onClick={clear}>
          {value && <Image src={require("assets/svgs/cross.svg").default} />}
        </InputRightElement>
      </InputGroup>
      {/* <Button
        onClick={() => { }}
        backgroundColor={'black'}
        border={'1px solid white'}
        borderRadius={'4px'}
        paddingInline={'32px'}
      >
        <Text
          letterSpacing={'1px'}
          fontSize={'12px'}
          fontFamily={'gothic'}
          color={'white'}
          textTransform={'uppercase'}
        >
          Search
        </Text>
      </Button> */}
    </Flex>
  );
};

export default Searchbar;
